import {useState, useEffect, useRef} from 'react';
import {useDispatch} from 'react-redux';
import {getReportsPhoto, getReportsVideo, setTime} from '../redux/actions/reports/reportsActions';

export const useMountTransition = (isMounted, unmountDelay) => {
  const [hasTransitionedIn, setHasTransitionedIn] = useState(false);

  useEffect(() => {
    let timeoutId;

    if (isMounted && !hasTransitionedIn) {
      setHasTransitionedIn(true);
    } else if (!isMounted && hasTransitionedIn) {
      timeoutId = setTimeout(() => setHasTransitionedIn(false), unmountDelay);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [unmountDelay, isMounted, hasTransitionedIn]);

  return hasTransitionedIn;
};

const useActivityControlledTimer = (id) => {
  const dispatch = useDispatch();
  const timerRef = useRef(null);
  const isActive = useRef(true); // Флаг активности страницы

  const minutes = 35 * 60 * 1000; // 15 секунд

  const getData = () => {
    dispatch(getReportsPhoto(id));
    dispatch(getReportsVideo(id));
  };

  const startTimer = () => {
    if (isActive.current) {
      timerRef.current = setTimeout(() => {
        dispatch(setTime());
        getData();
        startTimer();
      }, minutes);
    }
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      isActive.current = true;
      startTimer();
      getData();
    } else {
      isActive.current = false;
      stopTimer();
    }
  };

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);

    if (document.visibilityState === 'visible' && id && isActive.current) {
      startTimer();
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      stopTimer();
    };
  }, [dispatch, id]);

  return null;
};

export default useActivityControlledTimer;
